import { Router } from "@reach/router";
import { Suspense, useEffect } from "react";
import { JStore } from "../context/interfaces";
import { useJourneyState } from "../context/JourneyContext";
import { JourneyProps } from "./Interfaces";
import processJourney from "./processJourney";

import { StoreContext } from '../../context';
import { useContextSelector } from '@fluentui/react-context-selector';
import { flattenObject } from '../../utils/helpers';
import { actionTypeConstants } from '../../utils';

import { Auth } from 'aws-amplify';
const Journey: React.FC<JourneyProps> = (props) => {

    const appState: any = useContextSelector(StoreContext, store => store?.appState);
    const userInfoState: any = useContextSelector(StoreContext, store => store?.appState?.userInfo);
    const dispatch: any = useContextSelector(StoreContext, store => store?.dispatch);
    // will reomve this state merger once we have only one provider in place

    const { journeyStore } = useJourneyState();
    const flattenAppState = flattenObject(appState);

    const finalState = {
        ...journeyStore,
        ...flattenAppState
    };

    let tempValues = { ...journeyStore } as JStore

    let fields = safelyGetNested(["goal", "fields"], props);
    if (fields) {
        const goalFields = Object.keys(fields);
        if (goalFields.length > 0) {
            goalFields.forEach(key => {
                if (Object.is(tempValues[key], undefined)) {
                    tempValues[key] = ""
                }
            })
        }
    }

    useEffect(() => {
        if (userInfoState && !userInfoState.username) {
            Auth.currentAuthenticatedUser().then(user => {
                if (user) {
                    dispatch({
                        type: actionTypeConstants.UPDATE_USER,
                        payload: { ...user.attributes, "username": user.attributes.name }
                    });
                }
            }).catch(e => {
                // navigate("/login")
            })
        }
    }, [])

    let { routes } = processJourney(props, finalState);

    return <>
        <Suspense fallback={<div>Loading...</div>}>
            <Router className="text-center">
                {routes}
            </Router>
        </Suspense>
    </>
}

const callbackFn = (result: any, currentValue: any) => {
    return (result && result[currentValue]) ? result[currentValue] : null
}
const safelyGetNested = (keyPath: any[], props: object) => {
    return keyPath.reduce(callbackFn, props);
}

export default Journey;